var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414.745 97.2545C372.644 55.1526 315.541 31.5 256 31.5C196.459 31.5 139.356 55.1526 97.2545 97.2545C55.1526 139.356 31.5 196.459 31.5 256C31.5 315.541 55.1526 372.644 97.2545 414.745C139.356 456.847 196.459 480.5 256 480.5C315.541 480.5 372.644 456.847 414.745 414.745C456.847 372.644 480.5 315.541 480.5 256C480.5 196.459 456.847 139.356 414.745 97.2545ZM256 452.437C147.684 452.437 59.5632 364.316 59.5632 256C59.5632 147.684 147.684 59.5632 256 59.5632C364.316 59.5632 452.437 147.684 452.437 256C452.437 364.316 364.316 452.437 256 452.437ZM354.774 210.422C357.406 213.054 358.884 216.622 358.884 220.344C358.884 224.065 357.406 227.634 354.774 230.265L265.921 319.118C263.29 321.749 259.721 323.227 256 323.227C252.279 323.227 248.71 321.749 246.079 319.118L157.227 230.265C154.622 227.628 153.166 224.068 153.177 220.361C153.188 216.655 154.666 213.103 157.287 210.482C159.907 207.861 163.459 206.384 167.166 206.373C170.872 206.362 174.432 207.817 177.069 210.422L256 289.353L334.932 210.422C337.563 207.791 341.132 206.313 344.853 206.313C348.574 206.313 352.143 207.791 354.774 210.422Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.109fff22c0beb8b5b904fab1a9dacc5b.svg";
export { ForwardRef as ReactComponent };